import { HttpContext } from "@angular/common/http";
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { catchError, combineLatest, map, Observable, of } from "rxjs";
import { pathParamsHelper } from "../helpers/path-params.helper";
import { DefaultTechData } from "../pia-api/generated";
import { PiaProductDetailService } from "../pia-api/pia-product-detail.service";
import { IS_IN_RESOLVER_CONTEXT } from "../tokens/resolver-context.token";
import { withLoading } from "../utils/with-loading";

export const productTechDatalResolver: ResolveFn<
  Observable<DefaultTechData[] | null>
> = withLoading(
  (route: ActivatedRouteSnapshot): Observable<DefaultTechData[] | null> => {
    const productDetailsService = inject(PiaProductDetailService);

    const { countryID, languageID, year, productDetailID } =
      pathParamsHelper(route);

    const context = new HttpContext().set(IS_IN_RESOLVER_CONTEXT, true);

    return combineLatest([
      productDetailsService.getTechDataCategoriesByYearAndCountryAndLanguage(
        { countryID, languageID, year },
        context,
      ),
      productDetailsService.getProductTechDataByProductId(
        {
          countryID,
          languageID,
          year,
          productID: productDetailID,
        },
        context,
      ),
    ]).pipe(
      map(([cats, data]) => {
        const categoryMap = new Map(
          cats?.d?.results?.map((cat) => [cat.CategoryId, cat.Category]),
        );
        return (
          data?.map((item) => ({
            ...item,
            categoryTitle: categoryMap.get(item.CategoryId) || "N/A",
          })) || []
        );
      }),
      catchError((error) => {
        console.error(error);
        return of([]);
      }),
    );
  },
);
